import { Partial } from '@40seas/entities/common';
import { Billing } from './billing.entity';

export class UpdateBillingDto extends Partial(Billing) {}
